import { render, staticRenderFns } from "./renderForCartButton.vue?vue&type=template&id=015b1ab6"
import script from "./renderForCartButton.vue?vue&type=script&lang=js"
export * from "./renderForCartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports